import { useTranslation } from '../i18n';
import CustomerSupportSection from './platform-config/CustomerSupportSection';
import SensitiveWordsSection from './platform-config/SensitiveWordsSection';
import FeatureTogglesSection from './platform-config/FeatureTogglesSection';
import AvatarManagementSection from './platform-config/AvatarManagementSection';
import TermsLicenseSection from './platform-config/TermsLicenseSection';
import AppDownloadLinksSection from './platform-config/AppDownloadLinksSection';
import MemberMobileLinksSection from './platform-config/MemberMobileLinksSection';

interface IPlatformConfigProps {
  initialTab?: string;
  onTabChange?: (tab: string) => void;
}

const PlatformConfig = ({}: IPlatformConfigProps) => {
  const { t } = useTranslation();

  return (
    <div className="p-4 lg:p-8 flex flex-col gap-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">
          {t('config.title')}
        </h1>
        <p className="text-base text-gray-600 mt-2">{t('config.subtitle')}</p>
      </div>

      <CustomerSupportSection />
      <SensitiveWordsSection />
      <FeatureTogglesSection />
      <AvatarManagementSection />
      <TermsLicenseSection />
      <AppDownloadLinksSection />
      <MemberMobileLinksSection />
    </div>
  );
};

export default PlatformConfig;
